import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@/modules/common/components/Button';
import Spinner from '@/modules/common/components/Spinner';
import Checkbox from '@/modules/common/components/Checkbox';
import '../styles/DialogForm.scss';

const DialogForm = (props) => {
    return (
        <Dialog id={props.id} className="dialog-form" open={props.open} onClose={props.onClose}>
            <DialogTitle>{props.title}</DialogTitle>
            {(!props.loading)
                ? <form onSubmit={props.onSubmit}>
                    <DialogContent>{props.children}</DialogContent>
                    <DialogActions>
                        {(props.autoClose)
                            ? <div><Checkbox label="Закрывать окно после добавления"
                                        checked={props.autoClose.checked}
                                        onChange={props.autoClose.onChange}
                            /></div>
                            : null
                        }
                        <Button type="submit" disabled={props.disabled}>{props.label}</Button>
                    </DialogActions>
                </form>
                : <DialogContent><Spinner/></DialogContent>
            }
        </Dialog>
    );
};

DialogForm.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    autoClose: PropTypes.object,
};

DialogForm.defaultProps = {
    id: '',
};

export default DialogForm;
